import { useEffect } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';

const BackRedirectWatcher = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') {
      if (location.pathname == '/verify-code' || location.pathname == '/reset-password') {
        navigate('/forgotPassword');
        localStorage.setItem('email', null);
      }
    }
  }, [navigationType, location.pathname, navigate]);

  return null;
};

export default BackRedirectWatcher;
